module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "invitation"
  }, [(_vm.isSaving) ? _c('saver-large') : _vm._e(), _vm._v(" "), (!_vm.isSaving && !_vm.serverResponse) ? [_c('div', {
    staticClass: "avatar-container"
  }, [_c('avatar', {
    attrs: {
      "profile-data": _vm.invitation.gameDetails,
      "profile-type": "game",
      "size": "large",
      "show-xp-info": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('span', [_c('router-link', {
    attrs: {
      "to": ("/Game/" + (_vm.invitation.gameDetails.stringUrl))
    }
  }, [_c('i', {
    staticClass: "fas fa-gamepad"
  }), _vm._v(" " + _vm._s(_vm.invitation.gameDetails.alias))])], 1), _vm._v(" "), _c('span', [_vm._v("Recruiting for "), _c('span', {
    staticClass: "position-titles"
  }, [_vm._v(_vm._s(_vm.invitation.positionTitles))])]), _vm._v(" "), _c('ul', _vm._l((_vm.invitation.positions), function(position) {
    return _c('li', [_vm._v(_vm._s(position))])
  })), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendResponse('decline')
      }
    }
  }, [_vm._v("Decline")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendResponse('accept')
      }
    }
  }, [_vm._v("Accept")]), _vm._v(" "), _c('router-link', {
    staticClass: "button",
    attrs: {
      "tag": "button",
      "to": ("/Inbox/Compose?toId=" + (_vm.invitation.gameDetails.ownerDetails.id) + "&toAlias=" + (_vm.invitation.gameDetails.ownerDetails.alias))
    }
  }, [_vm._v("\n                Contact Game Project Owner\n            ")]), _vm._v(" "), (_vm.formErrors.length > 0) ? _c('div', {
    staticClass: "validation-messages error"
  }, _vm._l((_vm.formErrors), function(error) {
    return _c('span', [_vm._v(_vm._s(error))])
  })) : _vm._e()], 1)] : _vm._e(), _vm._v(" "), (_vm.serverResponse) ? [_c('div', {
    staticClass: "validation-messages friendly"
  }, [_vm._v(_vm._s(_vm.serverResponse))])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-36dbb9d8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/InvitationRequests/InviteToGameItem.vue
// module id = 849
// module chunks = 2